import React from 'react'
import { Iconify } from '../../Xmerald-UI'
import SimpleTooltip from '../Tooltip/SimpleTooltip'
import {
  TableContainer,
  TableHeader,
  TableRow,
  UserColumn,
  Avatar,
  DefaultAvatar,
  UserInfo,
  Nickname,
  AmountColumn,
  DateColumn,
  ActionColumn,
  ActionButton } from './styled'

const ReferralsTable = ({ referrals, onActionButton }) => {
  const formatCurrency = (amount) => {
    if (!amount) return '-'
    return `$${(amount / 100).toFixed(2)}`
  };

  const formatDate = (dateString) => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return date.toLocaleDateString('es-MX', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  }

  const getAvatarSrc = (referral) => {
    if (referral.referred_user.avatar && referral.referred_user.avatar_dir) {
      return `${referral.referred_user.avatar_dir}${referral.referred_user.avatar}`
    }
    return null;
  };

  const isVerified = (referral) => {
    return referral.referred_user.cashouts_verified === 4
  };

  return (
    <TableContainer>
      <TableHeader>
        <div>Usuario</div>
        <div style={{ textAlign: 'right' }}>Ganancias</div>
        <div style={{ textAlign: 'right' }}>Fecha</div>
        <div style={{ textAlign: 'center' }}>Recordar</div>
      </TableHeader>
      
      {referrals.map((referral) => (
        <TableRow key={referral.id}>
              <SimpleTooltip 
                content={
                  <div>
                    {isVerified(referral) 
                      ? '✅ Usuario verificado' 
                      : (
                        <div className='flex flex-col'>
                          <div><strong>{referral.referred_user.nick}</strong> aun no se ha verificado</div>
                          <div>puede verificar su cuenta en el menu de "Mi cuenta"'</div>
                        </div>
                      )
                    }
                  </div>
                }
                position="top"
                delay={300}
                hideDelay={200}
              >
          <UserColumn>
            {getAvatarSrc(referral) ? (
              <Avatar src={getAvatarSrc(referral)} alt="Avatar" />
            ) : (
              <DefaultAvatar><Iconify icon="mdi:account" color="#ffffff" /></DefaultAvatar>
            )}
      
            <UserInfo>
              <Nickname>{referral.referred_user.nick}</Nickname>
    
                <Iconify 
                  size={isVerified(referral) ? 20 : 14}
                  icon={isVerified(referral) ? 'stash:badge-verified-solid' : 'octicon:unverified-16'}
                  color={isVerified(referral) ? '#7bcb16' : '#dc3545'}
                />
            </UserInfo>

          </UserColumn>
          </SimpleTooltip>
          
          <AmountColumn>
            {formatCurrency(referral.amount_given)}
          </AmountColumn>
          
          <DateColumn>
            {formatDate(referral.purchase_date)}
          </DateColumn>
          
          <ActionColumn>
            <ActionButton onClick={() => onActionButton(referral)}>
              <Iconify icon="tabler:dots" />
            </ActionButton>
          </ActionColumn>
        </TableRow>
      ))}
    </TableContainer>
  );
};

export default ReferralsTable; 